import styled from 'styled-components';
import { ChipStyleMixin } from 'shared/styles';

export const SurveyName = styled.div`
  div.survey-name {
    display: flex;
    align-items: baseline;
    gap: 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 30px;
    color: #12344d;
  }
  div.survey-desc {
    font-weight: 400;
    font-size: 13px;
    line-height: 22px;
    color: #000000;
    opacity: 0.7;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .popular-label {
    ${ChipStyleMixin}
    font-weight: 600;
    color: #12344d;
    border: 1px solid #cfd7df;
    width: fit-content;
    border-radius: 4px;
  }
`;

export const Theme = styled.div`
  ${ChipStyleMixin}
  background: #ffffff;
  white-space: nowrap;
  border: 1px solid #cfd7df;
  border-radius: 4px;
  font-weight: 600;
  color: #12344d;
  width: fit-content;
`;

export const SameLineField = styled.div`
  white-space: nowrap;
`;
